export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      icon: 'toggle-on',
      title: 'Activate Selected Order Types',
      cls: "bulk-activate-order-types",
      disabled: false
    },
    {
      icon: 'toggle-off',
      title: 'Deactivate Selected Order Types',
      cls: "bulk-deactivate-order-types",
      disabled: false
    }
  ],
  "actions": [
    {
      title: "Edit Order Type",
      cls: "edit-order-type",
      icon: "pencil",
      disabled:false
    },
    {
      title: "Activate/Deactivate",
      cls: "",
      icon: "",
      disabled:false
    },
    {
      title:"Duplicate Order Type",
      cls:"duplicate-order-type",
      icon:"clone",
      disabled:false
    }
  ],
  "actionActiveDeactive": [
    {
    title: "Activate/Deactivate",
    cls: "",
    icon: "",
    disabled:false
    }
    ]
};



// WEBPACK FOOTER //
// ./src/pages/orderType/filter/actionOptions.js